import { AppBar as MuiAppBar, Toolbar, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Icon, Typography } from '@zenput/legacy-ui-components';

const { Headline } = Typography;

const useStyles = makeStyles()((theme) => {
    const { zenputColors, spacing } = theme;

    return {
        toolbar: {
            minHeight: spacing(8),
            paddingTop: 'env(safe-area-inset-top)',
            backgroundColor: 'var(--secondary-main)'
        },
        title: {
            color: zenputColors.white,
            fontWeight: 'normal',
            fontSize: '1.25em'
        }
    };
});

const AppBar = (props) => {
    const { title, onGoBack } = props;
    const { classes } = useStyles();

    return (
        <MuiAppBar position="relative" elevation={1}>
            <Toolbar className={classes.toolbar}>
                <IconButton
                    className="app_bar_go_back"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={onGoBack}
                    size="large"
                >
                    <Icon variant="df-back" />
                </IconButton>
                <Headline component="div" className={classes.title}>
                    {title}
                </Headline>
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBar;
